module.exports = __webpack_public_path__ + "img/step_two.8d5c5566.png";